const message_labels = {
  empty_error: "* Please enter Zip Code.",
  error: "* Please enter valid Zip Code.",
  not_found_error: "* Unfortunately, we currently don't deliver to this ZIP code.",
  not_valid_error: "* This is not a valid Zip Code in the United States.",
  no_result_found: "* No results found for the Zip Code."
};
const zipCodeRegex = /^\d{5}(-\d{4})?$/;
// const googleGeoCodeAPIKey = `AIzaSyDIOZZuJwy63lXotMpj_DDdxkdW2ZC6Gyw`;
const googleGeoCodeAPIKey = `AIzaSyC4Q5w18LDUKDF7i7P-M-xYyiKKb7ipZ2U`;
const defaultState = "Arizona";
const advance_yearly_product_subscription = {
  48393150660884: { variant_id: 50435696558356 },
  48619257856276: { variant_id: 50435696591124 },
  48393150726420: { variant_id: 50435696623892 },
  48619257889044: { variant_id: 50435696656660 },
};

const override_singlekit_prices = {
  50435696558356: "$39",
  50435696591124: "$69",
  50435696623892: "$39",
  50435696656660: "$69",
};

// NatureTek Product's Variants JSON
const ARRSIZEANDTREATMENT = {
  "4 Kits / Year / Single Gallon": 48393150660884,
  "6 Kits / Year / Single Gallon": 48393150726420,
  "4 Kits / Year / Double Gallon": 48619257856276,
  "6 Kits / Year / Double Gallon": 48619257889044,
  "One-Time Shipment / Standard Treatment Size": 51191692689684,
  "One-Time Shipment / XL Treatment Size": 51191758291220,
}

// Define arrays for states with different kit options
var sixKitStates = ["Alabama", "Arizona", "Arkansas", "California", "Florida", "Georgia", "Hawaii", "Kentucky", "Louisiana", "Mississippi", "Nevada", "New Hampshire", "New Mexico", "New York", "North Carolina", "South Carolina", "Tennessee", "Texas"];

/* Next Step Button Click */
let nextStep = 1;
let innerStep = false;

const strAnnualPrepayVariantInfo = $(`#annual_prepay_product_variants_info`).val();

let dynamic_class = 'hide-only-mobile';
if(window.innerWidth < 750){
  dynamic_class = 'show-only-mobile';
}

// Step 1: Parse the input string into arrPrepayVariantInfo
const arrPrepayVariantInfo = strAnnualPrepayVariantInfo.split(',');

arrPrepayVariantInfo.forEach(entry => {
  const parts = entry.split('##');
  let variantId, price;

  parts.forEach(part => {
    const [key, value] = part.split(':');
    if (key === 'variant_id') variantId = value;
    if (key === 'variant_price') price = value;
  });

  // Step 2: Loop through the object to match variant_id value
  Object.keys(advance_yearly_product_subscription).forEach(productId => {
    const item = advance_yearly_product_subscription[productId];
    if (item.variant_id == variantId) {
      item.variant_price = price;
    }
  });
});

/* Validate US based zipcode */
function isValidZipCode(zipcode) {
  return zipCodeRegex.test(zipcode);
}

/* Validate US based zipcode */
const geocodeAddress = async (zipCode) => {
  const geocoder = new google.maps.Geocoder();

  try {
    // Convert geocode to a Promise to use async/await
    const result = await new Promise((resolve, reject) => {
      geocoder.geocode({
        address: zipCode,
        componentRestrictions: { country: "US" }  // Restrict to United States
      }, (results, status) => {
          if (status === "OK") {
            resolve(results);
          } else {
            reject("Geocode failed: " + status);
          }
        }
      );
    });

    // If geocode is successful, process the results
    if (result && result.length > 0) {
      const addressComponents = result[0].address_components;
      let state = null;
      let city = null;

      // Loop through the address components to find the state
      addressComponents.forEach((component) => {
        if (component.types.includes("administrative_area_level_1")) {
          state = component.long_name;  // Store the state name
        }
        
        if (component.types.includes("locality")) {
          city = component.long_name;
        }
      });

      if (state) {
        return { city, state };  // Return the state
      } else {
        throw new Error(message_labels.not_valid_error);
      }
    } else {
      throw new Error(message_labels.no_result_found);
    }
  } catch (error) {
    // Catch any errors and log them
    console.error("Error:", error.message);
    return { error: error.message };  // Return the error
  }
};

/* After validating Zip Code function run */
// function fnDefaultProductSelection(validatedCity, validatedState) {
function fnDefaultProductSelection() {
  const zipValidateStepData = setPurchaseStepWiseData("zip-validate");
  // Guard: zip data may not exist yet when plan-selection is visited before zip entry
  const validatedState = zipValidateStepData ? zipValidateStepData.location.state : null;
  const validatedCity = zipValidateStepData ? zipValidateStepData.location.city : null;

  if(validatedState){
    $(`#state`).val(validatedState);
  }
  $(`.product-plan.product-subscription-plan input`).click();
  
  /* Jump on to next step with other process */
  if($(`.init-loader-conatiner`).hasClass(`active`)){
    $(`.init-loader-conatiner`).removeClass(`active`);
  }
  if(!($(`.customization-step[data-step=2]`).hasClass(`active`))){
    $(`.customization-step[data-step=2]`).addClass(`active`);
  }

  if($(`.zipcode-validator-container [data-validate-zipcode]`).attr(`disabled`)){
    $(`.zipcode-validator-container [data-validate-zipcode]`).removeAttr(`disabled`);
  }

  if(validatedState && sixKitStates.includes(validatedState)){
    $(`.year-round-kit`).addClass("is_active");
  } else {
    $(`.skip-winter-kit`).addClass("is_active");
  }
  
  // Retrieve current plan and handle and call getAndSetPriceOfSelVariant function
  const currentPlan = $('.yearly-schedule-kits .schedule-kit.is_active .kit-title').data(`actual-title`);
  const currentHandle = "naturetek";
  const sizeText = "Single Gallon";
  const offerTxt = $(`#${currentHandle}-offer-text`).val();
  var selectedPlan = `${currentPlan} / ${sizeText}`;
  
  if($(`.customization-step[data-step=2] [data-continuebtn]`).attr(`disabled`)){
    $(`.customization-step[data-step=2] [data-continuebtn]`).removeAttr(`disabled`);
  }

  getAndSetPriceOfSelVariant(currentHandle, selectedPlan, offerTxt);
}

// fetch selected product variant's price
function getAndSetPriceOfSelVariant(dataHandleValue, selectedPlan, offerText) {
  let flagOneTimeShipment = !($(`.product-plan.is_active`).hasClass(`product-subscription-plan`));
  
  if(dataHandleValue) {
    fetch(`/products/${dataHandleValue}.js`)
    .then(response => response.json())
    .then(product => {
      if(flagOneTimeShipment){
        selectedPlan = `One-Time Shipment / Standard Treatment Size`;
      }
      $(`#subscriptionPlan`).val(product.selling_plan_groups[0].name);
      var sellingPlan = product.selling_plan_groups[0].selling_plans[0].id;
      $(`#selling-plan`).val(sellingPlan);
      // const variant = product.variants.find(v => v.title.includes(selectedPlan));
      const variant = product.variants.find(v => (v.id == ARRSIZEANDTREATMENT[selectedPlan]));
      // document.querySelector('#discountAmount').innerHTML = offerText;
      $(`#selected-variant-id`).val(variant.id);
      $(`.singleUsePrice`).html(new Intl.NumberFormat('en-US', { style: 'currency', currency: Window.shop.currency, minimumFractionDigits: 0 }).format(variant.selling_plan_allocations[0].compare_at_price/100));
      $(`.old-price`).html(new Intl.NumberFormat('en-US', { style: 'currency', currency: Window.shop.currency, minimumFractionDigits: 0 }).format(variant.selling_plan_allocations[0].compare_at_price/100));
      $(`.discountPrice`).html(new Intl.NumberFormat('en-US', { style: 'currency', currency: Window.shop.currency, minimumFractionDigits: 0 }).format(variant.selling_plan_allocations[0].per_delivery_price/100));
    })    
    .catch(error => {
      console.error('Error fetching product data:', error);
    });
  }
}

// fetch selected product variant's price data for treatment-schedule cookie storage
function getTreatmentScheduleVariantPriceData(dataHandleValue, selectedPlan, offerText) {
  let flagOneTimeShipment = !($(`.product-plan.is_active`).hasClass(`product-subscription-plan`));

  if(!dataHandleValue) {
    return Promise.resolve(null);
  }

  return fetch(`/products/${dataHandleValue}.js`)
    .then(response => response.json())
    .then(product => {
      if(flagOneTimeShipment){
        selectedPlan = `One-Time Shipment / Standard Treatment Size`;
      }

      var sellingPlan = product.selling_plan_groups[0].selling_plans[0].id;
      const variant = product.variants.find(v => (v.id == ARRSIZEANDTREATMENT[selectedPlan]));
      if(!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations[0]){
        return null;
      }

      return {
        selected_variant_id: variant.id,
        selling_plan_id: sellingPlan,
        compare_price: new Intl.NumberFormat('en-US', { style: 'currency', currency: Window.shop.currency, minimumFractionDigits: 0 }).format(variant.selling_plan_allocations[0].compare_at_price / 100),
        price: new Intl.NumberFormat('en-US', { style: 'currency', currency: Window.shop.currency, minimumFractionDigits: 0 }).format(variant.selling_plan_allocations[0].per_delivery_price / 100)
      };
    })
    .catch(error => {
      console.error('Error fetching treatment schedule price data:', error);
      return null;
    });
}

/* Function call to find count the Pest issues */
function fnPestIssueFind(){
  var arrSelPestIssues = [];
  var strSelPestIssues = "None (preventative treatment).";
  $(`.pest-issues-container .pest-issues-insects-item-wrapper .pest-issue-item input:checked ~ .insect-item`).each(function(){
    arrSelPestIssues.push($(this).html());
  });
  
  if(arrSelPestIssues.length > 0){
    strSelPestIssues = arrSelPestIssues.join(",");
  }

  $(`#pest-issues-list`).html(strSelPestIssues);
}

/* First clear the cart and then add product to the cart */
function fnCartOperations(addVariantId, isSubscriptionPlan) {
  var formData;
  // First of all clear the cart and then process further to add product in the cart
  fnClearCart()
  .then(() => {
    var productPropertyObj = {};
    
    if(isSubscriptionPlan) {
      var planSelectionData = setPurchaseStepWiseData("plan-selection");
      let selling_plan;
      
      if(planSelectionData){
        selling_plan = planSelectionData.selling_plan_id;
        productPropertyObj = setCheckoutProductProperty(true);

        formData = {
          "id": addVariantId,
          "quantity": 1,
          "selling_plan": selling_plan,
          "properties": productPropertyObj
        };
      } else {
        // eraseStepCookieData("stepsData");
        window.history.replaceState( {}, window.location.href, window.location.pathname);
        window.location.reload();
      }
    } else {
      productPropertyObj = setCheckoutProductProperty(false);
      
      formData = {
        "items": [
          {
            "id": addVariantId,
            "quantity": 1,
            "properties": productPropertyObj
          }
        ] 
      };
    }
  })
  .then(() => {
    return fnAddProductToCart(formData);
  })
  .then(cart => {
    // eraseStepCookieData("stepsData");
    window.location.href = `/checkout`;
  })
  .catch(error => {
    console.error(`Error:`, error);
  });
}

/* Function call to clear the cart */
function fnClearCart() {
  return fetch(`/cart/clear.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then(response => response.json());
}

/* Function call to Add product to the cart */
function fnAddProductToCart(formData) {
  return fetch(`/cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  }).then(response => response.json());
}

/* Function call to scroll to the top of the page */
function fnSmoothScrollToTop(){
  $("html, body").animate({ scrollTop: 0 }, 400);
}

/* Cookie storage functions */
function setStepCookieData(name, value) {
  var expires = "";
  var date = new Date();
  const days = 90;
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getStepCookieData(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseStepCookieData(name) {
  document.cookie = `${name}=; Max-Age=0; path=/;`;
}

const arrSteps = ['plan-selection', 'zip-validate', 'pest-issues', 'treatment-schedule', 'plan-review'];

/* Updates lastVisitedStep in the cookie only if the given step is further than what was previously recorded */
function updateLastVisitedStep(step) {
  let data = getStepCookieData("stepsData");
  data = data ? JSON.parse(data) : {};
  const currentIdx = arrSteps.indexOf(step);
  const savedIdx = data.lastVisitedStep ? arrSteps.indexOf(data.lastVisitedStep) : -1;
  if (currentIdx > savedIdx) {
    data.lastVisitedStep = step;
    setStepCookieData("stepsData", JSON.stringify(data));
  }
}

/* Returns the furthest step the user has visited, based on lastVisitedStep stored in the cookie */
function getFurthestReachedStep() {
  let data = getStepCookieData("stepsData");
  if (!data) return null;
  data = JSON.parse(data);
  return data.lastVisitedStep || null;
}

/* Decide from which step we should recompute treatment schedule. */
function shouldRecomputeTreatmentSchedule(fromStep) {
  const furthest = getFurthestReachedStep();
  // Before user reaches plan-review: compute from pest-issues next action.
  if (furthest !== "plan-review") {
    return fromStep === "pest-issues";
  }
  // After plan-review was reached once and user restarts at zip-validate: compute from zip-validate.
  return fromStep === "zip-validate";
}

/* Returns the target URL — checks that all steps have their data before allowing jump ahead */
function getNextOrFurthestStepUrl(normalNextStep) {
  let data = getStepCookieData("stepsData");
  data = data ? JSON.parse(data) : {};
  
  const normalIdx = arrSteps.indexOf(normalNextStep);
  
  // Find the first step that doesn't have its required data saved
  // Start from step 0 and go up to normalNextStep
  for (let i = 0; i < normalIdx; i++) {
    const stepName = arrSteps[i];
    // Skip treatment-schedule validation — it's auto-populated
    if(stepName === "treatment-schedule") continue;
    if (typeof data[stepName] === "undefined") {
      // This step is missing data — navigate here
      return window.location.origin + window.location.pathname + '#' + stepName;
    }
  }
  
  // All previous steps have data — now check if we can jump further
  const furthest = data.lastVisitedStep || null;
  const furthestIdx = furthest ? arrSteps.indexOf(furthest) : -1;
  
  // Only jump to furthest if it's ahead AND all steps between normalNextStep and furthest have data
  if (furthestIdx > normalIdx) {
    let canJumpToFurthest = true;
    for (let i = normalIdx; i < furthestIdx; i++) {
      const stepName = arrSteps[i];
      // Skip treatment-schedule validation — it's auto-populated
      if(stepName === "treatment-schedule") continue;
      if (typeof data[stepName] === "undefined") {
        canJumpToFurthest = false;
        break;
      }
    }
    if (canJumpToFurthest) {
      return window.location.origin + window.location.pathname + '#' + furthest;
    }
  }
  
  // Default: go to the normal next step
  return window.location.origin + window.location.pathname + '#' + normalNextStep;
}

function identifyPurchaseStep() {
  // Check URL hash on page load and load data for that step
  var currentPurchaseStep = 'plan-selection';
  if(window.location.hash != '') {
    currentPurchaseStep = window.location.hash.replace('#', '');  // Get the step number from the URL
    if(!arrSteps.includes(currentPurchaseStep)){
      currentPurchaseStep = 'plan-selection';
    }
  }

  return currentPurchaseStep;
}

function setPurchaseStepWiseData(currentPurchaseStep) {
  var purchaseStepData = getStepCookieData("stepsData");
  if(purchaseStepData){
    purchaseStepData = JSON.parse(purchaseStepData);
    if(typeof(purchaseStepData[currentPurchaseStep]) != "undefined"){
      return purchaseStepData[currentPurchaseStep]; 
    }
    return null;
  }
  return purchaseStepData;
}

function updateStepData(stepKey, stepValue) {
  let data = getStepCookieData("stepsData");
  data = data ? JSON.parse(data) : {};
  data[stepKey] = stepValue;

  setStepCookieData("stepsData", JSON.stringify(data));
}

/* Compute default treatment-schedule data based on state and store in cookie */
async function computeAndStoreDefaultTreatmentSchedule(){
  const zipValidateData = setPurchaseStepWiseData("zip-validate");
  if(!zipValidateData) return null;
  
  const { location } = zipValidateData;
  const { state: validatedState } = location;
  
  // Determine default kit based on state
  let defaultKitTitle = sixKitStates.includes(validatedState) ? "6 Kits / Year" : "4 Kits / Year";
  let sizeText = "Single Gallon";
  let selectedPlan = defaultKitTitle + " / " + sizeText;
  let dataHandleValue = "naturetek";
  let offerText = "";
  const variantPriceData = await getTreatmentScheduleVariantPriceData(dataHandleValue, selectedPlan, offerText);
  
  // Get variant info
  const variantId = ARRSIZEANDTREATMENT[selectedPlan];
  let comparePrice = variantPriceData ? variantPriceData.compare_price : ($(`.product-subscription-plan .old-price`).html() || "");
  let price = variantPriceData ? variantPriceData.price : ($(`.product-subscription-plan .discountPrice`).html() || "");
    
  let arrStepsData = {
    selected_variant_id: variantPriceData && variantPriceData.selected_variant_id ? variantPriceData.selected_variant_id : variantId,
    compare_price: comparePrice,
    price: price,
    treatment_schedule: defaultKitTitle.trim().replace(/\s+/g, '').toLowerCase()
  };
  
  updateStepData('treatment-schedule', arrStepsData);
  return arrStepsData;
}

function setCheckoutProductProperty(isSubscriptionPlan = true){
  let arrCheckoutPropertyObj = {};
  var purchaseStepData = getStepCookieData("stepsData");
  if(purchaseStepData){
    purchaseStepData = JSON.parse(purchaseStepData);
    if(typeof(purchaseStepData["zip-validate"]) != "undefined"){
      arrCheckoutPropertyObj = { "_State": purchaseStepData["zip-validate"].location.state };
    }
    
    if(!isSubscriptionPlan){
      if(typeof(purchaseStepData["pest-issues"]) != "undefined"){
        var strPestIssuesList =  purchaseStepData["pest-issues"].list_pest_issues;
        var otherPestIssues = purchaseStepData["pest-issues"].other_pest_issues;
  
        if(typeof(strPestIssuesList) != "undefined" && strPestIssuesList != ""){
          if(strPestIssuesList != ""){
            arrCheckoutPropertyObj["_List of Pest issues"] = strPestIssuesList;
          }
        }
        
        if(typeof(otherPestIssues) != "undefined" && otherPestIssues != ""){
          if(otherPestIssues != ""){
            arrCheckoutPropertyObj["_Other Pest Issues"] = otherPestIssues;
          }
        }
      }
    }
  }
  return arrCheckoutPropertyObj;
}

function resetToInitPage(purchaseStep){
  if(window.location.hash != ''){
    // plan-selection is the first step — no previous step required
    if(purchaseStep === "plan-selection") return false;

    let cookieData = getStepCookieData("stepsData");
    cookieData = cookieData ? JSON.parse(cookieData) : null;

    if(cookieData == null){
      // No cookie at all — start fresh from step 1
      eraseStepCookieData("stepsData");
      window.history.replaceState( {}, window.location.href, window.location.pathname);
      window.location.reload();
      return true; // Redirecting
    }
    
    // treatment-schedule is only accessible via change link from plan-review
    if(purchaseStep === "treatment-schedule"){
      const allowTreatmentAccess = cookieData.allowTreatmentScheduleAccess;
      if(allowTreatmentAccess !== true){
        // Not allowed — redirect to plan-review if data exists, otherwise pest-issues
        let redirectStep = (typeof cookieData["treatment-schedule"] !== "undefined") ? "plan-review" : "pest-issues";
        let redirectUrl = window.location.origin + window.location.pathname + '#' + redirectStep;
        window.history.replaceState({}, "", redirectUrl);
        window.location.reload();
        return true;
      }
      // Clear the flag after using it
      delete cookieData.allowTreatmentScheduleAccess;
      setStepCookieData("stepsData", JSON.stringify(cookieData));
    }
    
    // Find the first incomplete step in the sequence before the requested purchaseStep
    const requestedIdx = arrSteps.indexOf(purchaseStep);
    for (let i = 0; i < requestedIdx; i++) {
      const stepName = arrSteps[i];
      // Skip treatment-schedule validation — it's auto-populated in background
      if(stepName === "treatment-schedule") continue;
      if (typeof cookieData[stepName] === "undefined") {
        // This step is missing data — redirect here
        let redirectUrl = window.location.origin + window.location.pathname + '#' + stepName;
        window.history.replaceState({}, "", redirectUrl);
        window.location.reload();
        return true; // Redirecting
      }
    }
    // All previous steps have data — allow current page to render
  }
  return false; // Not redirecting
}

/* Function call to way back to initial page */
$(".change-location").on("click", function () {
  $(".customization-step.active").removeClass("active");
  $(".customization-step[data-step=1]").addClass("active");
  if(!($(`.btn-previous-step`).hasClass(`hidden`))){
    $(`.btn-previous-step`).addClass(`hidden`);
  }
  $(`body`).removeClass(`pdp-footer-action`);
  window.history.pushState({ prev: window.location.href }, "", window.location.pathname + '#plan-selection');
});

/* Allow access to treatment-schedule step via change link from plan-review */
$(document).on("click", "a[href*='#treatment-schedule']", function(){
  let data = getStepCookieData("stepsData");
  data = data ? JSON.parse(data) : {};
  data.allowTreatmentScheduleAccess = true;
  setStepCookieData("stepsData", JSON.stringify(data));
});

/* After page loads performing below actions */
$(document).ready(function() {
  // Refresh stepsData cookie expiry to 3 months from current visit date
  const existingCookieData = getStepCookieData("stepsData");
  if(existingCookieData){
    setStepCookieData("stepsData", existingCookieData);
  }

  var purchaseStep = identifyPurchaseStep();
  
  // Always validate step access first — if redirecting, stop all further execution
  if(resetToInitPage(purchaseStep)){
    return; // Redirect is happening, don't render anything
  }
  
  var stepWiseData = setPurchaseStepWiseData(purchaseStep);

  if(purchaseStep == "zip-validate"){
    updateLastVisitedStep("zip-validate");
    const zipValidateData = setPurchaseStepWiseData("zip-validate");

    if(zipValidateData){
      const { zipCode } = zipValidateData;
      $(`#zip-input`).val(zipCode);
    }

    /* Jump on to next step with other process */
    if($(`.init-loader-conatiner`).hasClass(`active`)){
      $(`.init-loader-conatiner`).removeClass(`active`);
    }
    if(!($(`.customization-step[data-step=1]`).hasClass(`active`))){
      $(`.customization-step[data-step=1]`).addClass(`active`);
    }

    if($(`.zipcode-validator-container [data-validate-zipcode]`).attr(`disabled`)){
      $(`.zipcode-validator-container [data-validate-zipcode]`).removeAttr(`disabled`);
    }
    
    //$(document).on("click", ".zipcode-validator-container [data-validate-zipcode]", function() {
        // validation logic
   // });
    
    //$(`.zipcode-validator-container [data-validate-zipcode]`).on("click", function() {
    $(`.step-actionbar [data-validate-zipcode]`).on("click", function() {  
      if(!($(`.zipcode-validator-container [data-validate-zipcode]`).attr(`disabled`))){
        $(`.zipcode-validator-container [data-validate-zipcode]`).attr(`disabled`, `disabled`);
      }
      
      var zipCode = $(`#zip-input`).val();
      var flagZipError = false;
      var zipErrorMessage = ``;
      if(!zipCode || zipCode.trim() === ""){
        flagZipError = true;
        zipErrorMessage = message_labels.empty_error;
      } else {
        if(!zipCodeRegex.test(zipCode)){
          flagZipError = true;
          zipErrorMessage = message_labels.error;
        }
      }
      
      if(flagZipError){
        $(`#state`).val(``);
        if(!($(`.zipcode-validator-container #validate-message`).hasClass(`active_error`))){
          $(`.zipcode-validator-container #validate-message`).addClass(`active_error`);
        }
        if($(`.zipcode-validator-container [data-validate-zipcode]`).attr(`disabled`)){
          $(`.zipcode-validator-container [data-validate-zipcode]`).removeAttr(`disabled`);
        }
      } else {
        if($(`.zipcode-validator-container #validate-message`).hasClass(`active_error`)){
          $(`.zipcode-validator-container #validate-message`).removeClass(`active_error`);
        }
        
        // Check if zip code is unchanged from stored value — skip API call
        const existingZipData = setPurchaseStepWiseData("zip-validate");
        if(existingZipData && existingZipData.zipCode === zipCode && existingZipData.location){
          // Zip unchanged, skip Google API call and proceed directly
          let latestUrl = getNextOrFurthestStepUrl('pest-issues');
          window.history.pushState({ prev: window.location.href }, "", latestUrl);
          window.location.reload();
          return;
        }
        
        // ZipCode validator API call
        (async() => {
          geocodeAddress(zipCode)
          .then(location => {
            if(location.state) {
              const validatedState = location.state;
              const validatedCity = location.city;
              // Function call to process on initially product and plan selection phase.
              let arrStepsData = { zipCode: zipCode, location };
              updateStepData('zip-validate', arrStepsData);

              Promise.resolve(
                shouldRecomputeTreatmentSchedule("zip-validate")
                  ? computeAndStoreDefaultTreatmentSchedule()
                  : null
              ).finally(() => {
                let latestUrl = getNextOrFurthestStepUrl('pest-issues');
                window.history.pushState({ prev: window.location.href }, "", latestUrl);
                window.location.reload();
              });
              return;
            } else {
              zipErrorMessage = message_labels.not_found_error;
              if(location.error){
                zipErrorMessage = location.error;
              }
              $(`#state`).val(``);
              $(`#zip-input`).focus();
              $(`#validate-message`).html(zipErrorMessage);
              if(!($(`.zipcode-validator-container #validate-message`).hasClass(`active_error`))){
                $(`.zipcode-validator-container #validate-message`).addClass(`active_error`);
              }
              if($(`.zipcode-validator-container [data-validate-zipcode]`).attr(`disabled`)){
                $(`.zipcode-validator-container [data-validate-zipcode]`).removeAttr(`disabled`);
              }
            }
          });
        })()
      }
      $(`#validate-message`).html(zipErrorMessage);
    });
  }

  if(purchaseStep == "plan-selection"){
    // No hash (bare /products/naturetek) → always show plan-selection page, no auto-redirect.
    // With explicit #plan-selection → check saved data and skip ahead if possible.
    if(window.location.hash === "#plan-selection"){
      const furthestOnLoad = getFurthestReachedStep();
      if(furthestOnLoad && furthestOnLoad !== "plan-selection"){
        let redirectUrl = window.location.origin + window.location.pathname + '#' + furthestOnLoad;
        window.history.replaceState({}, "", redirectUrl);
        window.location.reload();
        return;
      }
    }

    updateLastVisitedStep("plan-selection");
    fnDefaultProductSelection();
    $(`body`).addClass(`current-step-2`);

    const zipValidateData = setPurchaseStepWiseData("zip-validate");
    var deliverableLocation = "your location";
    if(zipValidateData){
      const { location } = zipValidateData;
      const { city: validatedCity, state: validatedState } = location;
      deliverableLocation = validatedState;
      if(validatedCity != null){
        deliverableLocation = `${validatedCity}, ${validatedState}`;
      }
    } else {
      $(`.hidden-change-location-link`).addClass("hidden");
    }
    $(`.zip-based-location`).html(deliverableLocation);

    $(".product-plan").on('click', function() {
      $(".product-plan").removeClass("is_active");
      $(this).addClass("is_active");
      
      var isSelSubscriptionPlan = $(`.product-plan.is_active`).data(`subscribe`);
      if(typeof(isSelSubscriptionPlan) == "undefined"){
        $(`[data-checkoutbtn]`).removeClass("hidden");
        $(`[data-continuebtn]`).addClass("hidden");
      } else {
        $(`[data-continuebtn]`).removeClass("hidden");
        $(`[data-checkoutbtn]`).addClass("hidden");
      }

      // const currentPlan = $('.yearly-schedule-kits .schedule-kit.is_active .kit-title').data(`actual-title`);
      // const currentHandle = "naturetek";
      // const sizeText = "Single Gallon";
      // const offerTxt = "";
      // var selectedPlan = `${currentPlan} / ${sizeText}`;

      // getAndSetPriceOfSelVariant(currentHandle, selectedPlan, offerTxt);
    });

    $(`.customization-step[data-step=2] [data-continuebtn]`).on("click", function(){
      if(!($(`.customization-step[data-step=2] [data-continuebtn]`).attr(`disabled`))){
        $(`.customization-step[data-step=2] [data-continuebtn]`).attr(`disabled`, `disabled`);
      }

      let arrStepsData = { flagSubscriptionPlan: true, selling_plan_id: $(`#selling-plan`).val() };
      updateStepData('plan-selection', arrStepsData);
      let latestUrl = getNextOrFurthestStepUrl('zip-validate');
      window.history.pushState({ prev: window.location.href }, "", latestUrl);
      window.location.reload();
    });
    
    $(`.customization-step[data-step=2] [data-checkoutbtn]`).on("click", function(){
      var addProductVariantId = $(`#selected-variant-id`).val();
        
      // Function call to add subscription product to the cart
      fnCartOperations(addProductVariantId, false);
    });
  }

  if(purchaseStep == "pest-issues"){
    updateLastVisitedStep(purchaseStep);
    const pestIssuesData = setPurchaseStepWiseData("pest-issues");
    let subclass = (window.innerWidth > 749) ? "hide-only-mobile" : "show-only-mobile" ;

    if (pestIssuesData) {
      if(typeof(pestIssuesData.other_pest_issues) != "undefined"){
        $(`.pest-issues-container.${subclass} .other-issues-field #other-pest-issue`).val(pestIssuesData.other_pest_issues);
      }

      if(typeof(pestIssuesData.list_pest_issues) != "undefined"){
        let arrPestIssues = pestIssuesData.list_pest_issues;
        if(arrPestIssues){
          arrPestIssues = arrPestIssues.split(",");
          arrPestIssues.forEach((pest) => {
            $(`.pest-issues-container.${subclass} .pest-issues-insects-item-wrapper .pest-issue-item input[name="${pest.toLowerCase()}"]`).attr("checked", "checked");
          });
        }
      }
    }

    /* Jump on to next step with other process */
    if($(`.init-loader-conatiner`).hasClass(`active`)){
      $(`.init-loader-conatiner`).removeClass(`active`);
    }
    if(!($(`.customization-step[data-step=3]`).hasClass(`active`))){
      $(`.customization-step[data-step=3]`).addClass(`active`);
      $(`body`).addClass(`pdp-footer-action`);
    }

    $(`.customization-step[data-step=3] .next-action-button`).on("click", function(){
      /* Other Pest issues information find and set */
      var otherPestIssues = $(`.pest-issues-container.${subclass} .other-issues-field #other-pest-issue`).val();
      var arrSelPestIssues = [];
      var arrSelPestIssuesImgs = [];
      var strSelPestIssues = "";
      $(`.pest-issues-container.${subclass} .pest-issues-insects-item-wrapper .pest-issue-item input:checked ~ .insect-item`).each(function(){
        arrSelPestIssues.push($(this).html());
        arrSelPestIssuesImgs.push($(this).closest(`.pest-issue-item`).find(`img`).attr("src"));
      });
      
      if(arrSelPestIssues.length > 0){
        strSelPestIssues = arrSelPestIssues.join(",");
      }

      var purchaseStep = identifyPurchaseStep();
      let arrStepsData = { };
      arrStepsData["list_pest_issues"] = strSelPestIssues;
      arrStepsData["list_pest_issues_imgs"] = arrSelPestIssuesImgs;
      arrStepsData["other_pest_issues"] = otherPestIssues;
      

      if(Object.keys(arrStepsData).length > 0){
        updateStepData(purchaseStep, arrStepsData);
      }

      Promise.resolve(
        shouldRecomputeTreatmentSchedule("pest-issues")
          ? computeAndStoreDefaultTreatmentSchedule()
          : null
      ).finally(() => {
        let latestUrl = getNextOrFurthestStepUrl('plan-review');
        window.history.pushState({ prev: window.location.href }, "", latestUrl);
        window.location.reload();
      });
      return;
      
    });
  }

  if(purchaseStep == "treatment-schedule"){
    updateLastVisitedStep(purchaseStep);
    const zipValidateData = setPurchaseStepWiseData("zip-validate");
    const treatmentScheduleData = setPurchaseStepWiseData("treatment-schedule");
    var initSelectedPlan = "";
    var deliverableLocation = "your location";
    
    if(zipValidateData) {
      const { zipCode, location } = zipValidateData;
      const { city: validatedCity, state: validatedState } = location;
      deliverableLocation = validatedState;
      if(validatedCity != null){
        deliverableLocation = `${validatedCity}, ${validatedState}`;
      }
    } else {
      $(`.hidden-change-location-link`).addClass("hidden");
    }
    $(`#zip-based-location`).html(deliverableLocation);
    // Check if there's saved treatment-schedule data in cookie to restore selection
    if(treatmentScheduleData && treatmentScheduleData.treatment_schedule){
      // Restore saved selection
      if(treatmentScheduleData.treatment_schedule.indexOf("6kits") > -1){
        $(`#climate-type`).html("(warmer climate)");
        $(`#treatment-type`).html("year-round");
        $(`.year-round-kit`).addClass("is_active");
        $(`.year-round-kit input[type=radio]`).attr("checked", "checked");
      } else {
        $(`#climate-type`).html("(colder winter climate)");
        $(`#treatment-type`).html("skipping winter");
        $(`.skip-winter-kit`).addClass("is_active");
        $(`.skip-winter-kit input[type=radio]`).attr("checked", "checked");
      }
    } else {
      // Default selection based on state
      if(sixKitStates.includes(validatedState)){
        $(`#climate-type`).html("(warmer climate)");
        $(`#treatment-type`).html("year-round");
        $(`.year-round-kit`).addClass("is_active");
        $(`.year-round-kit input[type=radio]`).attr("checked", "checked");
      } else {
        $(`#climate-type`).html("(colder winter climate)");
        $(`#treatment-type`).html("skipping winter");
        $(`.skip-winter-kit`).addClass("is_active");
        $(`.skip-winter-kit input[type=radio]`).attr("checked", "checked");
      }
    }

    initSelectedPlan = $(`.schedule-kit.is_active`).find('.kit-title').data('actual-title');

    var selectedPlan = "";
    var sizeText = "Single Gallon";
    var dataHandleValue = "naturetek";
    var offerText = "";

    selectedPlan = initSelectedPlan + " / " + sizeText;
    getAndSetPriceOfSelVariant(dataHandleValue, selectedPlan, offerText);

    $('.product-kit-selection').on('click', function () {
      const $item = $(this);

      // Remove active from others, add to clicked
      $('.product-kit-selection').removeClass('is_active');
      $item.addClass('is_active');

      const $pricingTitle = $item.find('.kit-title');
      const handle = $pricingTitle.data('handle');

      selectedPlan = handle ? handle : $pricingTitle.data('actual-title');
      initSelectedPlan = selectedPlan;
      offerText = '';
      selectedPlan += " / " + sizeText;
      getAndSetPriceOfSelVariant(dataHandleValue, selectedPlan, offerText);
    });

    /* Jump on to next step with other process */
    if($(`.init-loader-conatiner`).hasClass(`active`)){
      $(`.init-loader-conatiner`).removeClass(`active`);
    }
    if(!($(`.customization-step[data-step=4]`).hasClass(`active`))){
      $(`.customization-step[data-step=4]`).addClass(`active`);
      $(`body`).addClass(`pdp-footer-action`);
    }

    $(`.customization-step[data-step=4] .next-action-button`).on("click", function(){
      var purchaseStep = identifyPurchaseStep();
      let arrStepsData = { selected_variant_id: $(`#selected-variant-id`).val(), compare_price: $(`.product-subscription-plan .old-price`).html(), price: $(`.product-subscription-plan .discountPrice`).html(), treatment_schedule: initSelectedPlan.trim().replace(/\s+/g, '').toLowerCase() };
      // console.log("Treatment schedule step - data to store in cookie:", arrStepsData);
      updateStepData(purchaseStep, arrStepsData);
      let latestUrl = getNextOrFurthestStepUrl('plan-review');
      window.history.pushState({ prev: window.location.href }, "", latestUrl);
      window.location.reload();
    });
  }

  if(purchaseStep == "plan-review"){
    updateLastVisitedStep(purchaseStep);

    const zipValidateData = setPurchaseStepWiseData("zip-validate");
    const pestIssuesData = setPurchaseStepWiseData("pest-issues");
    const treatmentScheduleData = setPurchaseStepWiseData("treatment-schedule");
    const planReviewData = setPurchaseStepWiseData("plan-review");

    const { location } = zipValidateData;
    const { city: validatedCity, state: validatedState } = location;
    var deliverableLocation = validatedState;
    if(validatedCity != null){
      deliverableLocation = `${validatedCity}, ${validatedState}`;
    }
    $(`.zip-location`).html(deliverableLocation);
    
    if(treatmentScheduleData){
      $(`.compare-price`).html(treatmentScheduleData.compare_price);
      $(`.discount-price`).html(treatmentScheduleData.price);
      
      if(pestIssuesData){
        if(typeof(pestIssuesData.other_pest_issues) != "undefined"){
          $(`.other-issues-text`).html(pestIssuesData.other_pest_issues ? pestIssuesData.other_pest_issues : "" );
          // if(pestIssuesData.other_pest_issues){
          //   $(`.other-issues-text`).html(pestIssuesData.other_pest_issues);
          // } else {
          //   $(`.other-issues-container`).addClass("hidden");
          // }
        }

        if(typeof(pestIssuesData.list_pest_issues) != "undefined"){
          let arrPestIssues = pestIssuesData.list_pest_issues;
          let arrPestIssuesImgs = pestIssuesData.list_pest_issues_imgs;
          let arrPestIssuesHTML = "";
          if(arrPestIssues){
            let arrPestIssuesItem = arrPestIssues.split(",");
            arrPestIssuesItem.forEach((pest, index) => {
              arrPestIssuesHTML += `
                <div class="issue-item">
                  <div class="image-wrapper">
                    <img
                      src="${arrPestIssuesImgs[index]}"
                      alt="${pest}"
                      class="pest-img"
                      width=""
                      height=""
                    >
                  </div>
                  <span class="pest-item">${pest}</span>
                </div>
              `;
            });  
          }
          $(`.issue-list`).html(arrPestIssuesHTML != "" ? arrPestIssuesHTML : "Preventative treatment (no pest issues selected)." );
          
          /* `About plan` section based one of the data dynamically replace pest-issues name */
          let replaceablePestIssuesElem = document.querySelectorAll(`.template-product:has(.product-step5) .about-plan-container .multicolumn-list__item .rte`);
          if(replaceablePestIssuesElem) {
            replaceablePestIssuesElem.forEach(elem => {
              let pestIssuesContent = elem.innerHTML;
              let slugPestIssues = arrPestIssues ? arrPestIssues.split(",").map(issue => issue.trim().toLowerCase()).join(", ") : "";
              if(pestIssuesContent.indexOf("#PEST_ISSUES_REPLACE#") > -1){
                elem.innerHTML = pestIssuesContent.replaceAll("#PEST_ISSUES_REPLACE#", slugPestIssues && slugPestIssues != "" ? slugPestIssues : "ants, silverfish, wasps");
              }
            });
          }
        }
      }

      if(treatmentScheduleData.treatment_schedule.indexOf("6kits") > -1){
        $(".skip-winter-txt").addClass("hidden");
        $(".skip-winter-treatment").addClass("hidden");
      } else {
        $(".year-round-txt").addClass("hidden");
        $(".year-round-treatment").addClass("hidden");
      }

      $(`.customization-step[data-step=5] .next-action-button`).on("click", function(){
        var addProductVariantId = treatmentScheduleData.selected_variant_id;
        
        // Function call to add subscription product to the cart
        fnCartOperations(addProductVariantId, true);
      });
    }
    
    /* Jump on to next step with other process */
    if($(`.init-loader-conatiner`).hasClass(`active`)){
      $(`.init-loader-conatiner`).removeClass(`active`);
    }
    if(!($(`.customization-step[data-step=5]`).hasClass(`active`))){
      $(`.customization-step[data-step=5]`).addClass(`active`);
      $(`body`).addClass(`pdp-footer-action`);
    }
  }

  setTimeout(() => {
    fnSmoothScrollToTop();
  }, 1500);

  $(window).on('popstate', function(event) {
    if(window.location.hash != "#bug-popup"){
      window.location.reload();
    }
  });
});

function updateLinkHref() {
  const link = document.querySelector(".pdp-header a.header__heading-link");
  const currentHash = window.location.hash;

  if (currentHash == "#zip-validate" || currentHash == "#pest-issues" || currentHash == "#treatment-schedule" || currentHash == "#plan-review") {
    // link.href = window.location.pathname + "#plan-selection";
    link.href = window.location.pathname;
  }
}

// Run once on page load
if($(`body`).hasClass(`template-product`)){
  updateLinkHref();
}

// Floating Footer Animation - Slide up after 1 second (only for desktop)
$(document).ready(function() {
  floatingFooterAnimate();
});

// Handle screen resize - add slide-up class when width > 749px
$(window).on('resize', floatingFooterAnimate);

function floatingFooterAnimate() {
  if (window.innerWidth > 749) {
    const delay = $(`product-info`).attr(`data-floating-footer-popup-delay`);
    if(typeof delay != "undefined" && delay > 0) {
      setTimeout(function() {
        if($('.product-step3 .step-continue-wrapper') != null) {
          $('.product-step3 .step-continue-wrapper').addClass('floating-footer');
          $('.floating-footer').addClass('slide-up');
        }
      }, (delay * 1000) );
    }
  } else {
    if($('.product-step3 .step-continue-wrapper') != null) {
      $('.floating-footer').removeClass('slide-up');
      $('.floating-footer').removeClass('floating-footer');
    }
  }
}